/**
 * @generated SignedSource<<f228402277a1bce0feaa16834c680999>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileSectionCollection_viewer$data = {
  readonly nftItemSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly metadata: {
          readonly name?: string | null;
        } | null;
        readonly mostRecentAuction: {
          readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftHeartPillProvider_viewer" | "NftItemTile_viewer">;
  readonly " $fragmentType": "NftProfileSectionCollection_viewer";
};
export type NftProfileSectionCollection_viewer$key = {
  readonly " $data"?: NftProfileSectionCollection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileSectionCollection_viewer">;
};

import NftProfileSectionCollectionPaginationQuery_graphql from './NftProfileSectionCollectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "nftItemSearch"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "collectionCursor"
    },
    {
      "kind": "RootArgument",
      "name": "collectionFirst"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "collectionFirst",
        "cursor": "collectionCursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "collectionFirst",
          "cursor": "collectionCursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftProfileSectionCollectionPaginationQuery_graphql
    }
  },
  "name": "NftProfileSectionCollection_viewer",
  "selections": [
    {
      "alias": "nftItemSearch",
      "args": [
        {
          "kind": "Literal",
          "name": "excludeOwnerCreatedItems",
          "value": true
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "ownerAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "ownerAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "ownerProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "ownerProfileUsernames"
        }
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "__NftProfileSectionCollection_nftItemSearch_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftItemSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "type": "NftDigitalArtMetadata",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "excludeCanceled",
                      "value": true
                    }
                  ],
                  "concreteType": "NftAuction",
                  "kind": "LinkedField",
                  "name": "mostRecentAuction",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NftItemTile_nftAuction"
                    }
                  ],
                  "storageKey": "mostRecentAuction(excludeCanceled:true)"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftItemTile_nftItem"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "8abfcc6c40cad2a4e9430d4d1ae35c5c";

export default node;
